module.exports = __webpack_public_path__ + "img/ne.142488e7.svg";